import { ExpandMoreRight } from './ExpandMoreRight';

export default ExpandMoreRight;
